export const _getErrorMessage = (error) => {
  if (typeof error == "string" || typeof error == "undefined") return error;
  else return "Something went wrong. Please try again.";
}